/** Formateo los estados para que lo acepte react-select */
export const formatEstados = (states) => {
  if (!states) return [];

  /** ANALIZAR PORQUE NO SE USO map, tratar de usar map */
  return states.reduce((acc, curr) => {
    acc.push(formatEstado(curr));

    return acc;
  }, []);
};

export const formatEstado = (estado) => {
  if (estado) {
    return {
      value: estado.id,
      label: estado.description,
      background_color: estado.background_color,
      color: estado.color,
    };
  }
};

export const formatProvider = (provider) => {
  if (provider) {
    return {
      value: provider.id,
      label: provider.persona?.correoElectronico ?? "userID: " + provider.id,
    };
  }

  return null;
};

export const formatProviders = (providers) => {
  if (!providers) {
    return [];
  }
  return providers.reduce((prev, curr) => {
    prev.push(formatProvider(curr));
    return prev;
  }, []);
};

export const formatModel = (model) => {
  if (model) {
    return {
      value: model.id,
      label: model.persona?.correoElectronico ?? "userID: " + model.id,
    };
  }

  return null;
};

export const formatModels = (models) => {
  if (!models) {
    return [];
  }
  if (!Array.isArray(models)) {
    models = models ? Object.values(models) : [];
  }
  return models.reduce((prev, curr) => {
    prev.push(formatModel(curr));
    return prev;
  }, []);
};
